/* global BaseUrl */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { getUrlTarget, urlIsExternal } from 'helpers/ContentHelper';

const HeaderLink = (props = {}, children, idx) => {
  const { to: route } = props;
  const targetData = getUrlTarget(route);
  const anchorProps = { ...props, ...targetData };
  const key = `link${route}.${idx}`;
  if (urlIsExternal(route)) {
    const isExternal = urlIsExternal(route);
    if (isExternal) {
      anchorProps.href = route;
    } else if (!isExternal && route) {
      anchorProps.href = `${BaseUrl}${route}`;
    }
    return (
      <a key={key} {...anchorProps}>
        {children}
      </a>
    );
  }
  return (
    <Link key={key} {...anchorProps}>
      {children}
    </Link>
  );
};

export default HeaderLink;

/* eslint react/require-default-props: 0 */
HeaderLink.propTypes = {
  to: PropTypes.string,
};
